import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { useStartDonationCount } from './-components/donation-count';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/new')({
	component: RouteComponent,
	// The `/new/$` catch-all covers a URL matching no route; this covers the other way in — a
	// `notFound()` raised by a page that does exist. Without it both fall through to the root's own
	// notFoundComponent, which is the PORTAL 404, chrome and all.
	notFoundComponent: NotFoundComponent,
});

/** Wrapped in the provider for the same reason RouteComponent is — see the note inside it. */
function NotFoundComponent() {
	const { i18n } = Route.useRouteContext();
	return (
		<I18nProvider i18n={i18n}>
			<NotFoundPage />
		</I18nProvider>
	);
}

function RouteComponent() {
	// Request-scoped Lingui instance from router context — see www/route.tsx.
	const { i18n } = Route.useRouteContext();
	// The live-donations count belongs to the whole visit: started here, it keeps running across
	// pages, so the odometer on Solutions reflects the time spent anywhere on the site.
	useStartDonationCount();
	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
